var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM11.0234 5.71406L7.73281 10.2766C7.68682 10.3408 7.62619 10.3931 7.55595 10.4291C7.48571 10.4652 7.40787 10.4841 7.32891 10.4841C7.24994 10.4841 7.17211 10.4652 7.10186 10.4291C7.03162 10.3931 6.97099 10.3408 6.925 10.2766L4.97656 7.57656C4.91719 7.49375 4.97656 7.37813 5.07812 7.37813H5.81094C5.97031 7.37813 6.12187 7.45469 6.21562 7.58594L7.32812 9.12969L9.78438 5.72344C9.87813 5.59375 10.0281 5.51562 10.1891 5.51562H10.9219C11.0234 5.51562 11.0828 5.63125 11.0234 5.71406Z",
    fill: "#3CB800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0231 5.71406L7.73252 10.2766C7.68653 10.3408 7.6259 10.3931 7.55566 10.4291C7.48541 10.4652 7.40758 10.4841 7.32862 10.4841C7.24965 10.4841 7.17182 10.4652 7.10157 10.4291C7.03133 10.3931 6.9707 10.3408 6.92471 10.2766L4.97627 7.57656C4.9169 7.49375 4.97627 7.37813 5.07783 7.37813H5.81065C5.97002 7.37813 6.12158 7.45469 6.21533 7.58594L7.32783 9.12969L9.78408 5.72344C9.87783 5.59375 10.0278 5.51562 10.1888 5.51562H10.9216C11.0231 5.51562 11.0825 5.63125 11.0231 5.71406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e0ad67e2c2b002a9c8c9cb83c752d97a.svg";
export { ForwardRef as ReactComponent };